export const TRANSITION_DURATION = 250;
